import { render, staticRenderFns } from "./BannerBlock.vue?vue&type=template&id=6c238c68&scoped=true&"
import script from "./BannerBlock.vue?vue&type=script&lang=js&"
export * from "./BannerBlock.vue?vue&type=script&lang=js&"
import style0 from "./BannerBlock.vue?vue&type=style&index=0&id=6c238c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c238c68",
  null
  
)

export default component.exports